import styled from 'styled-components'

import { Colors, FontFamily } from '@/utils'

import { ParagraphProps } from './Props'

const fonts = {
  sora: FontFamily.Sora,
  inter: FontFamily.Inter,
}

const resolveFontFamily = (props: ParagraphProps) => {
  if (props.fontFamily) {
    return props.fontFamily
  }
  const font = fonts[props.variant || 'inter']
  return font || FontFamily.Inter
}

type ColorsMap = typeof Colors
type ColorKey = keyof ColorsMap
type ColorValue = ColorsMap[ColorKey]

export function getKeyByValue(object: ColorsMap, value: string) {
  const colorEntries = Object.entries(object) as Array<[ColorKey, ColorValue]>
  const entry = colorEntries.find(([, currentValue]) => currentValue === value)
  return entry?.[0].toLocaleLowerCase()
}

const Paragraph = styled.p<ParagraphProps>`
  margin: ${({ margin }) => margin || '0 0 8px 0'};
  font-size: ${(props) => props.fontSize || '14px'};
  line-height: ${(props) => props.lineHeight || '17px'};
  font-weight: ${(props) => props.fontWeight || '400'};
  text-align: ${(props) => props.textAlign || 'unset'};
  color: ${(props) => `var(--${getKeyByValue(Colors, props?.color || Colors.GRAY400)})`};
  font-family: ${resolveFontFamily};
`

export default Paragraph
